<div class="p-3 bg-gray">
  <div class="row">
    <div class="d-flex justify-content-between">
      <div class="fs-16 fw-bold font-white mb-3">{{ areaData.AreaID ? "Update" : "Add" }} Area</div>
      <!-- <div [innerHtml]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" (click)="onClose()" tabindex="0" (keydown)="onClose()" class="cursor-pointer ms-auto"></div> -->
    </div>
    <div class="border-bottom mb-2 mt-2"></div>

    <div class="col-md-6 col-12 mb-5">
      <app-multi-select-dropdown
        label="Region"
        placeholder="Select a region"
        [items]="regionList"
        valueProperty="RegionID"
        displayProperty="RegionName"
        [model]="areaData.RegionID"
        (modelChange)="onRegionChange($event)">
      </app-multi-select-dropdown>
    </div>
    <div class="col-md-6 col-12 mt-2">
      <label for="areaName" class="fs-14 fw-normal font-white">Area Name <span class="text-danger">*</span></label>
      <input id="areaName" class="form-control bg-form-control border-0 font-white" onlyCharacter maxlength="45" [(ngModel)]="areaData.AreaName" name="areaName" placeholder="Enter Area Name" />
    </div>
    <div class="col-12 mt-5"></div>
    <div class="col-12"></div>

    <div class="d-flex justify-content-end mt-5">
      <button class="close-btn me-2 px-4 py-1" (click)="onClose()">Close</button>
      <button class="add-btn px-4 py-1" (click)="onSubmit()">{{ this.areaData.AreaID ? "Update" : "Add" }}</button>
    </div>
  </div>
</div>
